import React from 'react';
import { Typography, Box, Chip } from '@mui/material';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import SectionCard from '../ui/SectionCard';
import { STATUS_LABELS, getStatusHex } from '../../constants/status';
import { formatDateTime } from '../../utils/format';

// timeline แนวตั้ง เลียนแบบ StatusHistoryList.js/OwnerHistoryList.js — แต่ละแถวคือ 1 ครั้งที่มี
// คนเช็คอินเข้าโปรเจกต์นี้ (เขียนจากหน้า "เช็กอิน" — CheckinPage.js — คนละ flow กับหน้ารายละเอียดนี้
// เลยไม่มีปุ่มเพิ่ม/แก้ในการ์ดนี้ แค่แสดงประวัติ) employee_id เป็น loose reference ไป Mongo
// Employee เหมือน owner_id เลย resolve ชื่อผ่าน ownerNameById ตัวเดียวกัน ไม่ fetch ซ้ำ — ใช้
// created_at (มีเวลา) แสดงวัน+เวลาแทน checkin_date (เป็น @db.Date ล้วนๆ ไม่มีเวลา)
export function CheckinHistoryList({ history, ownerNameById }) {
  const items = (history || []).slice().reverse();

  return (
    <SectionCard icon={<EventAvailableOutlinedIcon />} title="ประวัติการเช็คอิน" accentColor="grey.500">
      {items.length === 0 ? (
        <Typography variant="body2" color="text.secondary">ยังไม่มีประวัติ</Typography>
      ) : (
        <Box>
          {items.map((h, idx) => (
            <Box key={h.id} sx={{ display: 'flex', gap: 1.5 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 12, flexShrink: 0 }}>
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    flexShrink: 0,
                    mt: 0.6,
                    bgcolor: getStatusHex(h.status),
                  }}
                />
                {idx < items.length - 1 && (
                  <Box sx={{ width: '1px', flex: 1, bgcolor: 'divider', my: 0.5 }} />
                )}
              </Box>
              <Box sx={{ pb: idx < items.length - 1 ? 2 : 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                  <Typography component="span" variant="body2" fontWeight={700}>
                    {ownerNameById?.[h.employee_id] || '(ไม่ทราบชื่อ)'}
                  </Typography>
                  {h.status && (
                    <Chip
                      size="small"
                      label={STATUS_LABELS[h.status] || h.status}
                      sx={{
                        height: 18,
                        fontSize: '0.68rem',
                        color: getStatusHex(h.status),
                        borderColor: getStatusHex(h.status),
                      }}
                      variant="outlined"
                    />
                  )}
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  {formatDateTime(h.created_at)}
                </Typography>
                {h.plan_note && (
                  <Typography variant="body2" sx={{ mt: 0.25, whiteSpace: 'pre-wrap' }}>{h.plan_note}</Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </SectionCard>
  );
}

export default CheckinHistoryList;
